import isNil from 'lodash/isNil';
import { useTranslation } from 'next-i18next';
import { useCallback } from 'react';

import { NumberInputPanel } from '@/components/Theme/NumberInputPanel';
import { ResetButton } from '@/components/Theme/ResetButton';
import { TooltipConfigProps } from '@/utils/tiptap/extensions/Tooltip/components/TooltipConfig';
import { FormControl } from '@/widgets/_components/FormControl';

export function Layout(props: TooltipConfigProps) {
  const { styles, onRemoveStyle, resolvedStyles, onUpdateStyle } = props;
  const { t } = useTranslation('components', { keyPrefix: 'theme.settings' });

  const setPadding = useCallback((newPadding: number) => onUpdateStyle({ padding: newPadding }), [onUpdateStyle]);

  const setOffset = useCallback((newOffset: number) => onUpdateStyle({ offset: newOffset }), [onUpdateStyle]);

  return (
    <FormControl title={t('layout')}>
      <NumberInputPanel
        label={t('padding')}
        value={resolvedStyles.padding}
        onChange={setPadding}
        ResetButton={!isNil(styles.padding) && <ResetButton onClick={() => onRemoveStyle('padding')} />}
      />
      <NumberInputPanel
        label={t('offset')}
        value={resolvedStyles.offset}
        onChange={setOffset}
        ResetButton={!isNil(styles.offset) && <ResetButton onClick={() => onRemoveStyle('offset')} />}
      />
    </FormControl>
  );
}
